export default "__VITE_ASSET__05b5944a__"